import { LocationUtils } from '@ctct/rise-utils';
import { type ComboboxItem } from '@ctct/summit-extended';
import { useTranslations } from 'next-intl';
import { type ComponentProps } from 'react';

import { type InputOpts } from '../../../types';
import { ComboboxInput } from '../../inputs-core';

const ProvinceCodeCombobox = ({
  formKey,
  registerOpts,
  buttonText: selectedValue,
  ...selectProps
}: InputOpts & Omit<ComponentProps<typeof ComboboxInput>, 'items'>) => {
  const t = useTranslations('UiForm');
  let comboboxItems: ComboboxItem[] = LocationUtils.provinces.map((province) => ({
    label: province.name,
    value: province.abbreviation,
  }));

  const selectedItem = comboboxItems.find(
    (item) => item.value?.toLowerCase() === selectedValue?.toLowerCase()
  );
  const filteredItems = selectedItem
    ? comboboxItems.filter((item) => item.value !== selectedItem.value)
    : comboboxItems;

  comboboxItems = selectedItem ? [selectedItem, ...filteredItems] : comboboxItems;

  return (
    <ComboboxInput
      formKey={formKey}
      registerOpts={registerOpts}
      placeholderText={t('shared.province.searchPlaceholder')}
      items={comboboxItems}
      buttonText={selectedValue}
      {...selectProps}
    />
  );
};

export { ProvinceCodeCombobox };
